import { BTPopover } from "@btnet/core-components/BTPopover";

import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

import { type PayrollEmployeeSyncStatus } from "entity/internalUser/InternalUserDetails/InternalUser.api.types";

interface IPayrollEmployeeSyncStatusDisplay {
    status: PayrollEmployeeSyncStatus;
    payrollIntegrationName: string;
}

export function PayrollEmployeeSyncStatusDisplay(props: IPayrollEmployeeSyncStatusDisplay) {
    const { status, payrollIntegrationName } = props;

    switch (status) {
        case "Synced":
            return <StatusTagDisplay statusText="Synced" statusType="success" />;
        case "Pending Setup in Gusto":
        case "Onboarding":
            return (
                <BTPopover
                    content={
                        "Further setup in " +
                        payrollIntegrationName +
                        " is required in order for time clock shifts to be synced."
                    }
                    placement="top"
                >
                    <span>
                        <StatusTagDisplay
                            statusType="pending"
                            statusText={"Pending Setup in " + payrollIntegrationName}
                        />
                    </span>
                </BTPopover>
            );
        case "Pending Setup":
            return (
                <BTPopover
                    content="User has more than one job in Gusto. Please select a single Gusto job"
                    placement="right"
                >
                    <span>
                        <StatusTagDisplay statusType="pending" statusText="Pending Setup" />
                    </span>
                </BTPopover>
            );
        default:
            return <></>;
    }
}
